import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const List = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const SettingItemContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SettingItemLinkIcon = styled.div`
  flex-shrink: 0;
  padding: 8px 0px;
  padding-left: 8px;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme }) => theme['font-secondary']};
    }
  }
`;

export const ToggleSwitchWrapper = styled.div`
  padding: 8px 0px;
`;

export const ToggleSwitch = styled.div<{ isActive: boolean }>`
  width: 40px;
  height: 24px;

  flex-shrink: 0;
  border-radius: 20px;
  position: relative;

  background-color: ${({ isActive, theme }) => (isActive ? theme['orange-primary'] : theme['gray-tertiary'])};

  transition: all 0.3s linear;
  div {
    width: 18px;
    height: 18px;
    margin-top: 3px;
    border-radius: 100%;
    background-color: white;

    position: absolute;
    left: ${({ isActive }) => !isActive && '3px'};
    right: ${({ isActive }) => isActive && '3px'};
  }
`;
